import { Injectable } from '@angular/core'
import { environment } from '@environments/environment'
import { WebsocketMessage } from '@venue-capacity/interfaces/websocket-message.interface'
import { webSocket, WebSocketSubject } from 'rxjs/webSocket'

@Injectable()
export class WebsocketService {
  private connection: WebSocketSubject<WebsocketMessage>

  public connect(workspace_slug, event_slug) {
    if (!this.connection) {
      this.connection = webSocket(`${environment.rtsWS}check-count/${workspace_slug}/${event_slug}`)
    }
    return this.connection
  }
}
